import { createInertiaApp, router, type ResolvedComponent } from '@inertiajs/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import posthog from 'posthog-js'
import type { SharedPageProps } from '../types/shared'
import './application.css'

function initializePostHog(initialPage: { props?: Partial<SharedPageProps> }) {
  const apiKey = initialPage.props?.posthogApiKey
  if (!apiKey) {return}

  posthog.init(apiKey, {
    api_host: `${window.location.origin}/ingest`,
    ui_host: 'https://us.posthog.com',
    capture_pageview: false,
  })

  router.on('navigate', () => {
    posthog.capture('$pageview')
  })
}

void createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<{ default: ResolvedComponent }>('../pages/**/*.tsx', {
      eager: true,
    })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(
        `Missing Inertia page component: '${name}.tsx'. ` +
          'Create it under app/frontend/pages/ (e.g. app/frontend/pages/Auth/SignIn.tsx).',
      )
    }
    return page
  },

  setup({ el, App, props }) {
    initializePostHog(props.initialPage as { props?: Partial<SharedPageProps> })

    createRoot(el).render(
      <StrictMode>
        <App {...props} />
      </StrictMode>,
    )
  },

  progress: {
    // keep in sync with --primary in application.css
    color: 'oklch(0.38 0.09 155)',
  },
})
